export default __webpack_public_path__ + "static/media/evas02.6ad2f94a.jpg";